export default __webpack_public_path__ + "static/media/Diplomatico.02b8f6f9.jpg";